export const redText = {
  color: '#C9372C',
  fontWeight: 700
};

const styles = {
  dialogPaper: {
    width: '340px',
    maxWidth: 'calc(100vw - 24px)',
    borderRadius: '16px',
    overflow: 'hidden',
    fontFamily: 'Nunito Sans',
    m: 0
  },
  noticeBox: {
    bgcolor: '#FFF0EF',
    px: '20px',
    py: '4px',
    minHeight: '44px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  noticeIcon: {
    color: '#C9372C',
    fontSize: '24px'
  },
  noticeText: {
    fontWeight: 700,
    color: '#C9372C',
    fontSize: '20px',
    lineHeight: '24px'
  },
  dialogContent: {
    px: '12px',
    pt: '12px',
    pb: '12px'
  },
  scrollWrapper: {
    position: 'relative'
  },
  scrollArea: {
    overflowY: 'auto',
    maxHeight: '240px',
    marginRight: '-6px',
    // Firefox + Chrome 121+
    scrollbarWidth: 'thin',
    scrollbarColor: '#D9D9D9 transparent',
    // Safari + older Chrome
    '&::-webkit-scrollbar': {
      width: '8px'
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#D9D9D9',
      borderRadius: '8px'
    }
  },
  textContainer: {
    m: 0,
    '& p': {
      mb: '14px',
      color: '#000000',
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: 500,
      '& strong': {
        fontWeight: 700
      }
    }
  },
  scrollTrack: {
    position: 'absolute',
    top: 0,
    right: '-6px',
    width: '4px',
    height: '100%',
    borderRadius: '8px',
    backgroundColor: 'transparent'
  },
  scrollThumb: {
    position: 'absolute',
    left: 0,
    width: '100%',
    borderRadius: '8px',
    backgroundColor: '#D9D9D9'
  },
  divider: {
    my: '12px',
    borderColor: '#B0B0B0'
  },
  checkbox: {
    p: 0,
    mt: '1px',
    color: '#8CA3BB',
    '& .MuiSvgIcon-root': { fontSize: '18px' },
    '&.Mui-checked': {
      color: '#044DA1'
    },
    '&.Mui-disabled': {
      color: '#8CA3BB'
    }
  },
  checkboxLabelText: {
    lineHeight: '16px',
    fontSize: '11px'
  },
  checkboxLabel: {
    alignItems: 'flex-start',
    m: 0,
    gap: '8px',
    '& .MuiFormControlLabel-label': { mt: 0 }
  },
  dialogActions: {
    p: 0,
    pt: '10px'
  },
  agreeButton: {
    py: '10px',
    px: '12px',
    borderRadius: '8px',
    boxShadow: '1px 4px 10px rgba(173, 173, 173, 0.16)',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 700
  },
  footerText: {
    mt: '10px',
    color: '#8CA3BB',
    textAlign: 'center',
    fontSize: '10px',
    lineHeight: '16px'
  }
};

export default styles;
